import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as licenseSelectors } from 'store/licenseManager'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import { navigationEvent } from 'layers/navigation/store/operations'
import { operations as reportsOperations } from 'store/reportsManager'
import {
  operations as ssapiOperations,
  selectors as ssapiSelectors,
} from 'store/ssapiManager'
import { ADMIN_DASHBOARD_ENTRY_ID } from 'utils/entryIds'
import PlaybookSteps from './component'
import { fieldNames } from './data'

const PlaybookStepsContainer = ({
  classCreationGoalValue,
  error,
  familyLetterSent,
  fetchK8PlaybookData,
  fetchPublishFlows,
  goal1Date,
  goal1IsCompleted,
  goal2Date,
  goal2IsCompleted,
  goal3Date,
  goal3Text,
  goal3IsCompleted,
  goal4Date,
  goal4IsCompleted,
  goal4Text,
  goal5Date,
  goal5Text,
  goal5IsCompleted,
  goalsAreCompleted,
  goalsIsInDraft,
  hasAllStepsCompleted,
  implementationApproachIsCompleted,
  isFetching,
  isSingleSite,
  kickoffHosted,
  kickoffPrepared,
  lessonCompletionGoalValue,
  linkDropdownDisplayTitle,
  linkMenu,
  navigationEvent,
  panelData,
  playbookData,
  programStartDate,
  purposeIsCompleted,
  purposeIsInDraft,
  showHeader,
  showMonitorViewOnly,
  siteId,
  siteName,
  stateDropdownOption,
  userEmail,
  userInvitationMethod,
}) => {
  useEffect(() => {
    if (siteId) {
      fetchPublishFlows(siteId)
    }
  }, [siteId])

  useEffect(() => {}, [
    classCreationGoalValue,
    error,
    familyLetterSent,
    goal1IsCompleted,
    goal2IsCompleted,
    goal3IsCompleted,
    goal4IsCompleted,
    goal5IsCompleted,
    goalsAreCompleted,
    goalsIsInDraft,
    implementationApproachIsCompleted,
    isFetching,
    kickoffHosted,
    kickoffPrepared,
    lessonCompletionGoalValue,
    linkDropdownDisplayTitle,
    linkMenu,
    navigationEvent,
    playbookData,
    programStartDate,
    purposeIsCompleted,
    purposeIsInDraft,
    stateDropdownOption,
    siteId,
    siteName,
    userEmail,
    userInvitationMethod,
  ])

  return (
    <PlaybookSteps
      classCreationGoalValue={classCreationGoalValue}
      familyLetterSent={familyLetterSent}
      fetchK8PlaybookData={fetchK8PlaybookData}
      goal1Date={goal1Date}
      goal1IsCompleted={goal1IsCompleted}
      goal2Date={goal2Date}
      goal2IsCompleted={goal2IsCompleted}
      goal3Date={goal3Date}
      goal3IsCompleted={goal3IsCompleted}
      goal3Text={goal3Text}
      goal4Date={goal4Date}
      goal4IsCompleted={goal4IsCompleted}
      goal4Text={goal4Text}
      goal5Date={goal5Date}
      goal5IsCompleted={goal5IsCompleted}
      goal5Text={goal5Text}
      goalsAreCompleted={goalsAreCompleted}
      goalsIsInDraft={goalsIsInDraft}
      hasAllStepsCompleted={hasAllStepsCompleted}
      implementationApproachIsCompleted={implementationApproachIsCompleted}
      isFetching={isFetching}
      isSingleSite={isSingleSite}
      kickoffHosted={kickoffHosted}
      kickoffPrepared={kickoffPrepared}
      lessonCompletionGoalValue={lessonCompletionGoalValue}
      linkDropdownDisplayTitle={linkDropdownDisplayTitle}
      linkMenu={linkMenu}
      navigationEvent={navigationEvent}
      panelData={panelData}
      playbookData={playbookData}
      programStartDate={programStartDate}
      purposeIsCompleted={purposeIsCompleted}
      purposeIsInDraft={purposeIsInDraft}
      showHeader={showHeader}
      showMonitorViewOnly={showMonitorViewOnly}
      siteId={siteId}
      siteName={siteName}
      stateDropdownOption={stateDropdownOption}
      userEmail={userEmail}
      userInvitationMethod={userInvitationMethod}
    />
  )
}

PlaybookStepsContainer.propTypes = {
  classCreationGoalValue: PropTypes.number,
  error: PropTypes.object,
  familyLetterSent: PropTypes.bool,
  fetchK8PlaybookData: PropTypes.func,
  fetchPublishFlows: PropTypes.func,
  goal1Date: PropTypes.number,
  goal1IsCompleted: PropTypes.bool,
  goal2Date: PropTypes.number,
  goal2IsCompleted: PropTypes.bool,
  goal3Date: PropTypes.number,
  goal3IsCompleted: PropTypes.bool,
  goal3Text: PropTypes.string,
  goal4Date: PropTypes.number,
  goal4IsCompleted: PropTypes.bool,
  goal4Text: PropTypes.string,
  goal5Date: PropTypes.number,
  goal5IsCompleted: PropTypes.bool,
  goal5Text: PropTypes.string,
  goalsAreCompleted: PropTypes.bool,
  goalsIsInDraft: PropTypes.bool,
  hasAllStepsCompleted: PropTypes.bool,
  implementationApproachIsCompleted: PropTypes.bool,
  isFetching: PropTypes.bool,
  isSingleSite: PropTypes.bool,
  kickoffHosted: PropTypes.bool,
  kickoffPrepared: PropTypes.bool,
  lessonCompletionGoalValue: PropTypes.number,
  linkDropdownDisplayTitle: PropTypes.string,
  linkMenu: PropTypes.array,
  navigationEvent: PropTypes.func,
  panelData: PropTypes.array,
  playbookData: PropTypes.object,
  programStartDate: PropTypes.number,
  purposeIsCompleted: PropTypes.bool,
  purposeIsInDraft: PropTypes.bool,
  showHeader: PropTypes.bool,
  showMonitorViewOnly: PropTypes.bool,
  siteId: PropTypes.string,
  siteName: PropTypes.string,
  stateDropdownOption: PropTypes.object,
  userEmail: PropTypes.string,
  userInvitationMethod: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
  const { contentful } = state || {}
  const {
    reportsManager,
    userProfileManager,
    ssapiManager,
    userSessionManager,
  } = state || {}
  const {
    admin: {
      k8: { isFetching, playbookData },
    },
    error,
  } = reportsManager || {}
  const { structureVersion } = ssapiManager || {}
  const {
    profile: { email: userEmail },
  } = userProfileManager || {}
  const {
    adminDashboard: {
      k8: { playbookStepsDropdown },
    },
  } = userSessionManager || {}
  const panelData =
    contentful?.[ADMIN_DASHBOARD_ENTRY_ID]?.payload?.leaderActivationPanel1 ||
    []
  const { navigationEvent } = ownProps || {}
  const adminK8Sites = licenseSelectors.selectActiveAdminK8Sites(state)
  const site = ownProps?.site || adminK8Sites?.[0] || {}
  const siteId = ownProps?.siteId || site.id
  const sitePreferences =
    ownProps?.sitePreferences || site?.sitePreferences || {}
  const { k5Digital } = sitePreferences || {}
  const {
    classCreationGoalDate,
    classCreationGoalValue,
    lessonCompletionGoalDate,
    lessonCompletionGoalValue,
    goal3Date,
    goal3Text,
    goal4Date,
    goal4Text,
    goal5Date,
    goal5Text,
  } = k5Digital || {}
  const stateDropdownOption = playbookStepsDropdown?.[site.id] || null
  const publishFlows = ssapiSelectors.selectPublishFlowsBySiteId(state, siteId)
  const publishFlow =
    publishFlows?.find(
      flow => flow.publishFlowStructureId === structureVersion,
    ) || {}
  const publishFlowData = {}

  fieldNames.forEach(fieldName => {
    publishFlowData[fieldName] =
      publishFlow?.publishFlowItems?.find(item => item.name === fieldName)
        ?.completeValue || null
  })

  const {
    CounselorLed: counselorLed,
    FamilyLetterSent: familyLetterSent,
    ImplementationType: implementationType,
    KickoffHosted: kickoffHosted,
    KickoffPrepared: kickoffPrepared,
    ProgramStartDate: programStartDate,
    Purpose: purpose,
    TeacherLed: teacherLed,
    UserInvitationMethod: userInvitationMethod,
  } = publishFlowData || {}

  const goal1IsCompleted = !!classCreationGoalDate && !!classCreationGoalValue
  const goal2IsCompleted =
    !!lessonCompletionGoalDate && !!lessonCompletionGoalValue
  const goal3IsCompleted = !!goal3Date && !!goal3Text
  const goal4IsCompleted = !!goal4Date && !!goal4Text
  const goal5IsCompleted = !!goal5Date && !!goal5Text

  const goalsAreCompleted =
    (goal1IsCompleted && goal2IsCompleted && !!programStartDate) || false
  const goalsIsInDraft =
    !goalsAreCompleted &&
    (classCreationGoalDate ||
      classCreationGoalValue ||
      goal3Date ||
      goal3Text ||
      goal4Date ||
      goal4Text ||
      goal5Date ||
      goal5Text ||
      lessonCompletionGoalDate ||
      lessonCompletionGoalValue ||
      programStartDate)

  // Check completion using flags first (if all flags are set)
  const hasAllCompletionFlags =
    !!implementationType && (teacherLed || counselorLed)

  // Fallback: check if values exist (for backward compatibility with data that wasn't saved with flags)
  // For programIsEnabled, check that it's explicitly set (not null), not just truthy
  const hasAllValues = !!implementationType && (teacherLed || counselorLed)

  // More lenient check: if implementationType and leader are completed,
  // consider it complete even if programIsEnabledIsCompleted is missing
  // (as long as programIsEnabled is explicitly set - false is valid)
  const hasCoreCompletion =
    !!implementationType &&
    implementationType !== null &&
    (teacherLed || counselorLed)

  const implementationApproachIsCompleted =
    hasAllCompletionFlags || hasAllValues || hasCoreCompletion || false
  const purposeIsInDraft = purpose === null
  const purposeIsCompleted = purpose?.length > 0
  const hasAllStepsCompleted =
    goalsAreCompleted && implementationApproachIsCompleted && purposeIsCompleted

  return {
    classCreationGoalValue,
    error,
    familyLetterSent,
    goalsAreCompleted,
    goal1Date: classCreationGoalDate,
    goal1IsCompleted,
    goal2Date: lessonCompletionGoalDate,
    goal2IsCompleted,
    goal3Date,
    goal3Text,
    goal3IsCompleted,
    goal4Date,
    goal4IsCompleted,
    goal4Text,
    goal5Date,
    goal5IsCompleted,
    goal5Text,
    goalsIsInDraft,
    hasAllStepsCompleted,
    implementationApproachIsCompleted,
    isFetching,
    kickoffHosted,
    kickoffPrepared,
    lessonCompletionGoalValue,
    navigationEvent,
    panelData,
    playbookData,
    programStartDate,
    purposeIsCompleted,
    purposeIsInDraft,
    siteId,
    siteName: site.name,
    stateDropdownOption,
    userEmail,
    userInvitationMethod,
  }
}

const mapDispatchToProps = {
  fetchPublishFlows: ssapiOperations.fetchPublishFlows,
  navigationEvent,
  fetchK8PlaybookData: reportsOperations.fetchK8PlaybookData,
}

const mapper = entry => {
  const { displayTitle, linkMenu } = entry || {}
  return {
    linkDropdownDisplayTitle: displayTitle,
    linkMenu,
  }
}

const options = {
  entryId: '7CIaQNOLCEQvJMd8GHkCeP',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    PlaybookStepsContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
